import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { new_ErrorAlert } from "../export_spwk/ExportManager";

dayjs.extend(customParseFormat);

class DateHelper {
  static IsYear2999(dt_str: string): Boolean {
    if (dt_str == null || dt_str === "") {
      throw new_ErrorAlert("4646116 dt_str: 沒有填值 !!!");
    } else {
      return dayjs(dt_str).year() === 2999;
    }
  }

  static StrToDayjs(dt_str: string): Dayjs {
    return dayjs(dt_str);
  }

  static StrToDate(dt_str: string): Date {
    const re = new Date(dt_str);
    return re;
  }

  static 字串轉西元日期(dt_str: string): string {
    if (dt_str === null || dt_str === undefined) {
      return "";
    }
    return dayjs(dt_str).format("YYYY/MM/DD");
  }

  static 取得當前時間(): string {
    return dayjs().format("YYYY/MM/DD HH:mm:ss");
  }

  /**
 * 獲取指定日期前後的日期
 * @param {string} dt - 指定的日期，格式為 YYYY-MM-DD
 * @param {number} amount - 要添加或減去的數量
 * @param {'year' | 'month' | 'day'} unit - 要添加或減去的單位：'year'、'month' 或 'day'
 * @returns {string} - 格式化後的日期字符串，格式為 YYYY/MM/DD
 */
  static 當前時間前後(dt: string, amount: number, unit: 'year' | 'month' | 'day'): string {
    // 將提供的日期轉換為 Day.js 物件
    const dtObj = dayjs(dt);

    // 根據單位進行加法運算
    let result: dayjs.Dayjs;
    switch (unit) {
      case 'year':
        result = dtObj.add(amount, 'year');
        break;
      case 'month':
        result = dtObj.add(amount, 'month');
        break;
      case 'day':
        result = dtObj.add(amount, 'day');
        break;
      default:
        throw new Error("無效的單位");
    }

    // 返回結果格式化後的字串
    return result.format("YYYY/MM/DD");
  }


  static DayjsToStr(dt: Dayjs): string {
    return dt.format("YYYY/MM/DD");
  }
  static IsBlankDay(day_str: string): boolean {
    let tf =
      day_str == null ||
      day_str === "" ||
      day_str.includes("1800") ||
      day_str.includes("2999") ||
      day_str.includes("0000");
    return tf;
  }

  /**
   * 指出此字串是否為純日期字串
   * @param str 日期字串
   * @returns
   */
  static IsDate(str: string): boolean {
    return dayjs(str, "YYYY-MM-DD", true).isValid();
  }

  /**
   * 指出此字串是否包含日期及時間
   * @param str 日期時間字串
   * @returns
   */
  static IsDateTime(str: string): boolean {
    return dayjs(str, "YYYY-MM-DD HH:mm:ss", true).isValid();
  }
}

export default DateHelper;
